<template >
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px">
            <span style="width: 63px; background-color: #589ff9" @click="openChildDialog(1)">
              <img src="../../images/increase.png" style="width: 15px; height: 15px" alt="" />
            </span>
          </div>
          <div @click="dialogVisible_one = true"
            style="    width: 80px;height: 25px;cursor: pointer;display: flex;border: 1px solid #589ff9;margin-left:10px;justify-content: center;border-radius: 5px;">
            <span style="font-size: 14px;">filter</span>
          </div>

          <el-tooltip class="item" effect="dark" content="客户姓名" placement="bottom" v-if="name">
            <el-input placeholder="客户姓名" v-model="name" clearable @change="getList"
              :class="{ 'vip': name && name.length != '0' }">
            </el-input>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="市场维护" placement="bottom" v-if="staff">
            <el-select v-model="staff" filterable placeholder="市场维护" @change="staffChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': staff && staff !== '市场维护' }">
              <el-option v-for="(item, index) in staff_one" :key="index" :label="item.name" :value="item.staff_id">
              </el-option>
            </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="市场开发" placement="bottom" v-if="first_sales">
            <el-select v-model="first_sales" filterable placeholder="市场开发" @change="first_salesChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': first_sales && first_sales !== '市场开发' }">
              <el-option v-for="(item, index) in first_sales_one" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>


          <el-tooltip class="item" effect="dark" content="客户类型" placement="bottom" v-if="type">
            <el-select v-model="type" filterable placeholder="客户类型" @change="typeChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': type && type !== '客户类型' }">
              <el-option v-for="(item, index) in type_one" :key="index" :label="item.value_1" :value="item.type_id">
              </el-option>
            </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="客户区域" placement="bottom" v-if="region">
            <el-select v-model="region" filterable placeholder="客户区域" @change="regionChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': region && region !== '客户区域' }">
              <el-option v-for="(value, key) in region_one" :key="key" :label="value.name" :value="value.id">
              </el-option>
            </el-select>
          </el-tooltip>



          <el-tooltip class="item" effect="dark" content="客户地点" placement="bottom" v-if="area">
            <el-input placeholder="客户地点" clearable v-model="area" @change="getList"
              :class="{ 'vip': area && area.length != '0' }"></el-input>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="来源方式" placement="bottom" v-if="source">
            <el-select v-model="source" filterable placeholder="来源方式" @change="sourceChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': source && source !== '来源方式' }">
              <el-option v-for="(value, key) in source_one" :key="key" :label="value.name" :value="value.id">
              </el-option>
            </el-select>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="初次合作" placement="bottom" v-if="value0">
            <el-date-picker v-model="value0" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
              start-placeholder="初次合作" align="right" :class="{ 'your-css-class_box': !isValue3Empty_1 }"
              value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="最后合作" placement="bottom" v-if="value1">
            <el-date-picker v-model="value1" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
              start-placeholder="最后合作" align="right" :class="{ 'your-css-class_box': !isValue3Empty_2 }"
              value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="合作状态" placement="bottom" v-if="work_status">
            <el-cascader @change="work_status_box" v-model="work_status" placeholder="合作状态" :options="options2"
              filterable :class="{ 'vip': work_status && work_status.length != '0' }">
            </el-cascader>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="跟进时间" placement="bottom" v-if="value2">
            <el-date-picker v-model="value2" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
              start-placeholder="跟进时间" align="right" :class="{ 'your-css-class_box': !isValue3Empty_3 }"
              value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="跟进人" placement="bottom" v-if="remark_creator">
            <el-select v-model="remark_creator" filterable placeholder="跟进人" @change="remark_creatorChange"
              style="margin-left: 6px;" clearable :class="{ 'vip': remark_creator && remark_creator !== '跟进人' }">
              <el-option v-for="(value, key) in remark_creator_one" :key="key" :label="value.realname" :value="key">
              </el-option>
            </el-select>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="跟进内容" placement="bottom" v-if="customer_remark_remark">
            <el-input placeholder="跟进内容" v-model="customer_remark_remark" clearable @change="getList"
              :class="{ 'vip': customer_remark_remark && customer_remark_remark !== '跟进内容' }"></el-input>
          </el-tooltip>
          <span style="width: 69px;border:1px solid #589ff9;margin-left: 5px" @click="cleanUpEvt"
            v-if="hasContent">ALL</span>

          <span style="margin-left: 5px;border: 1px solid #589ff9 ;" @click="excelEvt">EXCEL</span>
        </div>
        <div class="over_box" style="width: 100%;">
          <span class="span_box">{{ total }}</span>
          <div class="btn2">
            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"
                @change="limitEvt"></el-input>
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5">
              </el-pagination>
            </div>
            <button @click="minxEvt" :class="{ active: activeTab === '1' }">基本信息</button>
            <button @click="min_boxEvt" :class="{ active: activeTab === '2' }">签单情况</button>
            <button @click="min_oneEvt" :class="{ active: activeTab === '3' }">历年汇总</button>
            <button @click="min_twoEvt" :class="{ active: activeTab === '4' }">制作内容</button>
            <button @click="min_box_three" :class="{ active: activeTab === '5' }" v-if="userRole != 3">成本统计</button>
            <button @click="min_four" :class="{ active: activeTab === '6' }">跟进情况</button>
          </div>
          <el-table :data="tableData" ref="sortTable" height="55%" border @cell-mouse-enter="huaguo" @cell-click="idEvt"
            @sort-change="sortChangeEvt" v-sort-orders="['descending', 'ascending', '']">
            <el-table-column prop="name" label="客户名称" sortable="custom" :sort-orders="orders" width="315px"
              fixed="left">
              <template slot-scope="props">
                <span @click="openChildDialog(2)">{{ props.row.name }}</span>
              </template>
            </el-table-column>
            <template v-if="showNameColumn">
              <el-table-column prop="staff_name" sortable="custom" :sort-orders="orders" label="市场维护" width="100">
              </el-table-column>

              <el-table-column prop="first_sales" sortable="custom" :sort-orders="orders" label="市场开发" width="100">
              </el-table-column>


              <el-table-column prop="value_1" sortable="custom" :sort-orders="orders" label="客户类型" width="120">
              </el-table-column>
              <el-table-column prop="region" sortable="custom" :sort-orders="orders" label="客户区域" width="120">
              </el-table-column>
              <el-table-column prop="area" sortable="custom" :sort-orders="orders" label="客户地点" width="180">
              </el-table-column>
              <el-table-column prop="source" sortable="custom" :sort-orders="orders" label="来源方式" width="120">
              </el-table-column>
              <el-table-column prop="source_remark" sortable="custom" :sort-orders="orders" label="来源说明" width="250">
                <template slot-scope="props">
                  <span class="white_over">{{ props.row.source_remark }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="first_cooperation" label="初次合作" sortable="custom" :sort-orders="orders"
                width="100">
              </el-table-column>
              <el-table-column prop="last_cooperation" sortable="custom" :sort-orders="orders" label="最后合作" width="100">
              </el-table-column>
              <el-table-column prop="work_status" label="合作状态" sortable="custom" :sort-orders="orders" width="100">
              </el-table-column>
              <el-table-column prop="customer_remark" sortable="custom" :sort-orders="orders" label="跟进时间" width="100">
              </el-table-column>
              <el-table-column prop="customer_remark_remark" label="跟进详情" sortable="custom" :sort-orders="orders">
                <template slot-scope="props">
                  <span class="white_over">{{ props.row.customer_remark_remark }}</span>
                </template>
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box">
              <el-table-column prop="staff_name" label="市场维护" sortable="custom" :sort-orders="orders" width="100">
              </el-table-column>
              <el-table-column prop="month_total" label="合计" sortable="custom" :sort-orders="orders" width="105"
                class-name="project_one">
              </el-table-column>
              <el-table-column prop="month_1" label="1月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_2" label="2月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_3" label="3月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_4" label="4月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_5" label="5月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_6" label="6月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_7" label="7月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_8" label="8月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_9" label="9月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_10" label="10月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_11" label="11月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="month_12" label="12月" sortable="custom" :sort-orders="orders" width="80"
                class-name="project_two">
              </el-table-column>
              <el-table-column prop="year_back" label="当年项目回款" sortable="custom" :sort-orders="orders" width="110">
              </el-table-column>
              <el-table-column prop="year_unback" label="当年项目未回款" sortable="custom" :sort-orders="orders" width="110">
              </el-table-column>
              <el-table-column prop="year_back_total" label="当年所有回款" sortable="custom" :sort-orders="orders"
                width="110">
              </el-table-column>
              <el-table-column prop="year_project" label="当年项目数量" sortable="custom" :sort-orders="orders">
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box_one">
              <el-table-column prop="staff_name" label="市场维护" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="back_period" label="回款周期" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="unback_period" label="未回周期" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="total_amount" label="历年总签单" width="110" sortable="custom" :sort-orders="orders"
                class-name="project_three">
              </el-table-column>
              <el-table-column prop="year_amount_2026" label="2026" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2025" label="2025" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2024" label="2024" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2023" label="2023" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2022" label="2022" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2021" label="2021" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2020" label="2020" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2019" label="2019" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2018" label="2018" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="year_amount_2017" label="2017" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_Free">
              </el-table-column>
              <el-table-column prop="total_back" label="历年总回款" width="120" sortable="custom" :sort-orders="orders"
                class-name="project_sex_one">
              </el-table-column>
              <el-table-column prop="year_back_2026" label="2026" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2025" label="2025" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2024" label="2024" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2023" label="2023" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2022" label="2022" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2021" label="2021" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2020" label="2020" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2019" label="2019" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2018" label="2018" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="year_back_2017" label="2017" width="80" sortable="custom" :sort-orders="orders"
                class-name="project_sex_two">
              </el-table-column>
              <el-table-column prop="total_unback" label="历年总未回" width="120" sortable="custom" :sort-orders="orders"
                class-name="name_one">
              </el-table-column>
              <el-table-column prop="year_unback_2026" label="2026" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2025" label="2025" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2024" label="2024" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2023" label="2023" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2022" label="2022" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2021" label="2021" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2020" label="2020" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2019" label="2019" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2018" label="2018" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="year_unback_2017" label="2017" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_two">
              </el-table-column>
              <el-table-column prop="total_project" label="历年数量" width="120" sortable="custom" :sort-orders="orders"
                class-name="box_one">
              </el-table-column>
              <el-table-column prop="year_project_2026" label="2026" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2025" label="2025" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2024" label="2024" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2023" label="2023" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2022" label="2022" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2021" label="2021" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2020" label="2020" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2019" label="2019" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2018" label="2018" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
              <el-table-column prop="year_project_2017" label="2017" width="80" sortable="custom" :sort-orders="orders"
                class-name="box_two">
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box_two">
              <el-table-column prop="staff_name" label="市场维护" width="120" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="type_plan" label="规划" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_birdview" label="鸟瞰" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_perspective" label="透视" width="80" sortable="custom" class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_indoor" label="室内 " width="80" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_vr" label="VR" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_animation" label="动画" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="type_plan_amount" label="规划" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="type_birdview_amount" label="鸟瞰" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="type_perspective_amount" label="透视" width="80" sortable="custom"
                class-name="name_four" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="type_indoor_amount" label="室内 " width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="type_vr_amount" label="VR" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="type_animation_amount" label="动画" width="80" sortable="custom"
                :sort-orders="orders" class-name="name_four">
              </el-table-column>
              <el-table-column prop="" label="">
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box_three">
              <el-table-column prop="staff_name" label="市场维护" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="model_cost" label="模型" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="render_cost" label="渲染" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="assistant_cost" label="助理" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four">
              </el-table-column>
              <el-table-column prop="total_cost" label="总成本" width="80" sortable="custom" :sort-orders="orders"
                class-name="name_four_one">
              </el-table-column>
              <el-table-column prop="model_rate" label="模型比例" width="100" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="render_rate" label="渲染比例" width="100" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="assistant_rate" label="助理比例" width="100" sortable="custom" :sort-orders="orders"
                class-name="name_three">
              </el-table-column>
              <el-table-column prop="total_rate" label="总成本比例" width="100" sortable="custom" :sort-orders="orders"
                class-name="name_three_one">
              </el-table-column>
              <el-table-column prop="">
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box_four">
              <el-table-column prop="staff_name" label="客户维护" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="customer_remark" label="跟进时间" width="100" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="realname" label="跟进人" width="90" sortable="custom" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="customer_remark_remark" label="跟进内容" sortable="custom" :sort-orders="orders">
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </el-main>

    <el-dialog :visible.sync="dialogVisible" :show-close="false" custom-class="maxss" width="1539px" height="885px"
      :top="dialogTop" style="overflow: hidden;">
      <div class="whole" ref="whole">
        <div style="width: 360px;margin-left: 10px; position: fixed;">
          <div class="cloneEvt">
            <span @click="seekEvt" style="cursor: pointer;">保存</span>
            <span @click="DelEvt" style="cursor: pointer;">删除</span>
          </div>
          <div style="width: 360px;">
            <div class="Completion_status">
              <el-form ref="form" :model="input1" label-width="50px" size="mini">
                <el-form-item label="客户名" style=" font-size: 12px; padding:0px 10px 0px 10px; margin-top: 20px;"
                  class="text_one">
                  <el-input v-model="names" style="width:280px;margin-left: 7px;"></el-input>
                </el-form-item>
                <el-form-item label="登记日期" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top:10px"
                  class="text_one">
                  <el-date-picker v-model="register_time" style="width: 280px;margin-left: 6px;" type="date">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="客户类型" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top:35px"
                  class="text_one">
                  <el-select v-model="type_id_one" filterable placeholder="客户类型" style="width:280px"
                    @change="type_idChange" clearable :class="{ 'vip': type && type !== '客户类型' }">
                    <el-option v-for="(item, index) in type_one" :key="index" :label="item.value_1"
                      :value="item.type_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户地点" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top:10px"
                  class="text_one">
                  <el-input v-model="areas" style="width:280px"></el-input>
                </el-form-item>
                <el-form-item label="客户区域" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top:10px"
                  class="text_one">
                  <el-select v-model="region_name" filterable placeholder="客户区域" @change="region_oneChange" clearable>
                    <el-option v-for="(value, key) in region_one" :label="value.name" :value="value.id" :key="key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="维护人员" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top:35px"
                  class="text_one">
                  <el-select v-model="staff_id" filterable placeholder="维护人员" @change="staff_oneChange" clearable>
                    <el-option v-for="(item, index) in staff_one" :key="index" :label="item.name"
                      :value="item.staff_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="height:480px; margin-top: 10px; border: 1px solid #d9d9d9;border-radius: 5px;background: #fff;">
              <el-form ref="form" :model="input1" label-width="50px" size="mini">
                <el-form-item label="来源方式" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top: 10px;"
                  class="text_one">
                  <el-select v-model="source_name" filterable placeholder="来源方式" @change="source_oneChange" clearable>
                    <el-option v-for="(value, key) in source_one" :key="key" :label="value.name" :value="value.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="来源说明" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top: 10px;"
                  class="text_one">
                  <textarea name="" id="" cols="37" rows="11" v-model="source_remark"
                    style="outline: none;border: 1px solid #d9d9d9;border-radius: 5px;padding: 10px 0;text-indent: 0.8em;"></textarea>
                </el-form-item>

                <el-form-item label="跟进情况" style=" font-size: 12px; padding:0px 10px 0px 10px;margin-top: 10px;"
                  class="text_one">
                  <textarea name="" id="" cols="37" rows="11" v-model="remark"
                    style="outline: none;border: 1px solid #d9d9d9;border-radius: 5px;padding: 10px 0;text-indent: 0.8em;"></textarea>
                </el-form-item>

              </el-form>

            </div>

          </div>
        </div>
        <div class="banner">
          <div style="display:flex;height: 24px;">
            <span @click="showTab('tab1')" :class="{ active: activeTab_one === 'tab1' }" ref="tab1"
              :style="{ backgroundColor: activeTab_one === 'tab1' ? '#3383EA' : '#979797', color: '#fff', padding: '3px 21px', borderRadius: '3px' }">项目明细</span>
            <span @click="showTab('tab2')" :class="{ active: activeTab_one === 'tab2' }" ref="tab2"
              :style="{ backgroundColor: activeTab_one === 'tab2' ? '#3383EA' : '#979797', color: '#fff', padding: '3px 21px', borderRadius: '3px', marginLeft: '10px' }">跟进情况</span>
          </div>
          <div v-if="activeTab_one == 'tab1'">
            <div
              style="height: 155px;border: 1px solid  #d1d1d1;border-radius: 5px;margin-top: 10px;background-color: #fff;">
              <div class="seek">
                <div>
                  <p><span style="margin-top:7px">总签单</span><span style="font-weight: 600;font-size: 22px;"> {{
                      customer.total_amount }}</span></p>
                  <span>
                    <p>总回款 <span style="margin-left:1px;"
                        :style="{ color: customer.total_back == 0 ? '#979797' : '#fff' }"> {{ customer.total_back
                        }}</span></p>
                    <p>总未回 <span style="margin-left:1px;"
                        :style="{ color: customer.total_unback == 0 ? '#979797' : '#fff' }">{{ customer.total_unback
                        }}</span></p>
                  </span>
                </div>
                <div>
                  <p><span style="margin-top:7px">完工未回</span><span style="font-weight: 600;font-size: 22px;"> {{
                      5000000}}</span></p>
                </div>
                <div>
                  <p><span style="margin-top:7px">溢价率 </span><span style="font-weight: 600;font-size: 22px;">{{
                      customer.premium_rate }}%</span></p>
                  <span>
                    <p>最后合作 <span style="margin-left:1px;"
                        :style="{ color: customer.last_cooperation == 0 ? '#979797' : '#fff' }">{{
                        customer.last_cooperation }}</span></p>
                    <p>最初合作 <span style="margin-left:1px;"
                        :style="{ color: customer.first_cooperation == 0 ? '#979797' : '#fff' }">{{
                        customer.first_cooperation }}</span></p>
                  </span>
                </div>
                <div>
                  <p><span style="margin-top:7px">回款周期</span> <span
                      style="margin-left:1px;font-weight:600;font-size: 22px;"
                      :style="{ color: customer.back_period == 0 ? '#979797' : '#fff' }">{{ customer.back_period
                      }}</span></p>
                  <p>未回周期 <span style="margin-left:1px;"
                      :style="{color: customer.unback_period  == 0 ? '#979797' :'#fff'}">{{ customer.unback_period
                      }}</span></p>
                </div>
                <div>
                  <p><span style="margin-top:7px">项目单价 </span><span style="font-weight: 600;font-size: 22px;">{{ 25600
                      }}</span></p>
                  <span>
                    <p>历年数量 <span style="margin-left:1px;"
                        :style="{ color: customer.total_project == 0 ? '#979797' : '#fff' }">{{ customer.total_project
                        }}</span></p>
                    <!-- <p>当年签单{{ customer.year_amount }}</p> -->
                    <p>当年数量<span style="margin-left:1px;"
                        :style="{color: customer.year_total  == 0 ?'#979797':'#fff' }">{{ customer.year_total }}</span>
                    </p>
                  </span>
                </div>
              </div>
            </div>
            <div class="content" style="margin-top: 10px; overflow: hidden;">
              <el-table :data="tableData_one" style="width:1150px; overflow-y: auto;" max-height="645px" show-summary
                :summary-method="getSummariesEvt" class="manx" @sort-change="sortChangeEvt_two"
                v-sort-orders="['descending', 'ascending', '']">
                <el-table-column prop="name" label="项目名称" width="300" sortable="custom" :sort-orders="orders">
                </el-table-column>
                <el-table-column prop="start_time" :sort-orders="orders" sortable="custom" label="开始时间" width="120">
                </el-table-column>
                <el-table-column prop="end_time" :sort-orders="orders" sortable="custom" label="完工时间" width="120">
                </el-table-column>
                <el-table-column prop="income_time" :sort-orders="orders" sortable="custom" label="回款时间" width="120">
                </el-table-column>
                <el-table-column prop="converted_amount" :sort-orders="orders" sortable="custom" label="合同折算"
                  width="100">
                </el-table-column>
                <el-table-column prop="backed_amount" :sort-orders="orders" sortable="custom" label="回款折算" width="120">
                </el-table-column>
                <el-table-column prop="wait_amount" :sort-orders="orders" sortable="custom" label="未回折算" width="120">
                </el-table-column>
                <el-table-column prop="sign" :sort-orders="orders" sortable="custom" label="签单人">
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="activeTab_one == 'tab2'">
            <div style="height: 810px;margin-top: 10px;background-color: #fff;border-radius: 5px;width:1140px">
              <div style="display: flex;flex-direction: column">
                <div
                  style="height: 40px; display: flex; font-size: 12px;background: #EBF0F3;line-height: 40px;width:1120px;margin-left: 10px;margin-top: 10px;gap: 100px;">
                  <span style="margin-left:10px ;">时间</span>
                  <span @click="addItem" style="cursor: pointer;margin-left: 10px;">新增</span>
                </div>
                <div class="follow_up">
                  <div v-for="(item, index) in items" :key="index" class="foll_up">
                    <span style="margin-left:10px;width:95px;line-height: 40px;">{{ getCurrentDate() }}</span>
                    <el-input type="textarea" autosize class="img_s" v-model="remark"
                      style="left: 30px;position: relative;"></el-input>
                    <img @click="deleteItem(index)" src="../../images/x.png" alt="" srcset="" class="img_se">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>



    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" >
      <div style="height:360px;">
        <span
          style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px;"
          @click="cleanUpEvt">ALL</span>
        <div style="height:300px;display:flex">
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>客户姓名</span>
                <el-input  v-model="name" clearable @change="getList"
                  :class="{ 'vip': name && name.length != '0' }" style="width: 180px;height: 40px;">
                </el-input>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 15px;">
              <span>市场维护</span>
                <el-select v-model="staff" filterable  @change="staffChange"
                  style="margin-left: 6px;width: 180px;height: 40px;" clearable
                  :class="{ 'vip': staff && staff !== '市场维护' }">
                  <el-option v-for="(item, index) in staff_one" :key="index" :label="item.name" :value="item.staff_id">
                  </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 15px;">
              <span>市场开发</span>
                <el-select v-model="first_sales" filterable  @change="first_salesChange"
                  style="margin-left: 6px;width: 180px;height: 40px;" clearable
                  :class="{ 'vip': first_sales && first_sales !== '市场维护' }">
                  <el-option v-for="(item, index) in first_sales_one" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
            </div>



            <div style="margin-top: 10px;margin-left: 15px;">
              <span>来源方式</span>
                <el-select v-model="source" filterable  @change="sourceChange"
                  style="margin-left: 6px; width: 180px;height: 40px;" clearable
                  :class="{ 'vip': source && source !== '来源方式' }">
                  <el-option v-for="(value, key) in source_one" :key="key" :label="value.name" :value="value.id">
                  </el-option>
                </el-select>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>客户类型</span>
                <el-select v-model="type" filterable  @change="typeChange"
                  style="margin-left: 6px;width: 180px;height: 40px; " clearable
                  :class="{ 'vip': type && type !== '客户类型' }">
                  <el-option v-for="(item, index) in type_one" :key="index" :label="item.value_1" :value="item.type_id">
                  </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>客户区域</span>
                <el-select v-model="region" filterable  @change="regionChange"
                  style="margin-left: 6px;width:180px;height: 40px;" clearable
                  :class="{ 'vip': region && region !== '客户区域' }">
                  <el-option v-for="(value, key) in region_one" :key="key" :label="value.name" :value="value.id">
                  </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>客户地点</span>
                <el-input  clearable v-model="area" @change="getList"
                  :class="{ 'vip': area && area.length != '0' }"
                  style="width: 180px;height: 40px;margin-left: 6px;"></el-input>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>初次合作</span>
                <el-date-picker v-model="value0" style="width: 137px;margin-left: 6px;width: 180px;height: 40px;"
                  type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                  start-placeholder="" align="right" :class="{ 'your-css-class_box': !isValue3Empty_1 }"
                  value-format="timestamp" @change="getList">
                </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>最后合作</span>
                <el-date-picker v-model="value1" style="width: 180px;margin-left: 6px;height: 40px;" type="daterange"
                  :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                  start-placeholder="" align="right" :class="{ 'your-css-class_box': !isValue3Empty_2 }"
                  value-format="timestamp" @change="getList">
                </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>合作状态</span>
                <el-cascader @change="work_status_box" v-model="work_status"  :options="options2"
                  filterable :class="{ 'vip': work_status && work_status.length != '0' }"
                  style="width: 180px;height: 40px;">
                </el-cascader>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>跟进时间</span>
                <el-date-picker v-model="value2" style="width: 137px;margin-left: 6px;width: 180px;height: 40px;"
                  type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                  start-placeholder="" align="right" :class="{ 'your-css-class_box': !isValue3Empty_3 }"
                  value-format="timestamp" @change="getList">
                </el-date-picker>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>跟进人</span>
                <el-select v-model="remark_creator" filterable  @change="remark_creatorChange"
                  style="margin-left: 6px;width: 180px;height: 40px;margin-left: 10px;" clearable
                  :class="{ 'vip': remark_creator && remark_creator !== '跟进人' }">
                  <el-option v-for="(value, key) in remark_creator_one" :key="key" :label="value.realname" :value="key">
                  </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>跟进内容</span>
                <el-input  v-model="customer_remark_remark" clearable @change="getList"
                  :class="{ 'vip': customer_remark_remark && customer_remark_remark !== '跟进内容' }"
                  style="width: 180px;height: 40px;"></el-input>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPCustomerApi, ERPCutApi, InfoTwoApi, editTwoApi, CustDelApi } from "@/api/staff/staff.js";

const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    GlobalHeader
  },
  data() {
    return {
      activeIndex: "5",
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },


      options1: [{
        value: '1',
        label: '上门拜访',
      }, {
        value: '2',
        label: '网络开发',
      }, {
        value: '3',
        label: '推荐',
      }, {
        value: '4',
        label: '自主上门',
      }],
      options2: [{
        value: '1',
        label: '合作过',
      }, {
        value: '2',
        label: '未合作',
      }, {
        value: '3',
        label: '一年内合作',
      }, {
        value: '4',
        label: '一年内没合作',
      }],
      isValue3Empty_1: true,
      isValue3Empty_2: true,
      isValue3Empty_3: true,

      source: null,
      status: null,
      //排序
      order: null,
      orField: null,

      staff_one: null,
      type_one: null,
      source_one: null,
      region_one: null,
      first_sales_one:null,
      remark_creator_one: null,
      name: null,
      staff: null,
      first_sales:null,
      type: null,
      area: null,
      region: null,
      work_status: null,
      value0: '',
      value1: '',
      value2: '',
      customer_remark_remark: null,
      remark_creator: null,


      total: null,
      paginationInput: 96,
      currentPage1: 1,
      department_one: null,
      settlement: null,
      department_two: null,
      settlement_one: null,
      settlement_tow: null,
      totalRow: null,

      showNameColumn: true,
      showNameColumn_box: false,
      showNameColumn_box_one: false,
      showNameColumn_box_two: false,
      showNameColumn_box_three: false,
      showNameColumn_box_four: false,
      activeTab: '1',
      dialogVisible: false,
      input1: null,

      customer: [],
      register_time: '',
      type_id_one: null,
      region_name: null,
      source_name: null,
      staff_id: null,
      source_remark: null,
      remark: null,
      totalRowData: [],
      names: null,
      areas: null,
      tableData_one: [],
      orders: ['descending', 'ascending', null],

      dialogTop: null, // 初始值为1vh
      userRole: null,
      loading: false,

      activeTab_one: 'tab1',
       items: [
        { remark: '', value: '3' }
      ],
      dialogVisible_one:false,
    };
  },
  created() {
    this.loading = true
    ERPCustomerApi({}).then((res => {
      this.tableData = res.data;
      this.total = res.total,
        this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading = false;
    }))

    ERPCutApi({}).then((res => {
      this.staff_one = res.data.staff   //市场维护
      this.first_sales_one = res.data.first_sales   //市场开发
      this.type_one = res.data.type   //客户类型
      this.source_one = res.data.source //来源方式
      this.region_one = res.data.region //客户区域
      this.remark_creator_one = res.data.remark_creator //跟进人
    }))
    this.userRole = localStorage.getItem('role');
  },
  mounted() {
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    hasContent() {
      const fields = [
        this.name,
        this.staff,
        this.first_sales,
        this.type,
        this.region,
        this.area,
        this.source,
        this.value0,
        this.value1,
        this.work_status,
        this.value2,
        this.remark_creator,
        this.customer_remark_remark,
      ];
      // 检查所有字段的长度是否为0
      return fields.some(field => (field && (Array.isArray(field) ? field.length > 0 : field !== '')));
    }
  },
  methods: {
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
     deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem() {
      const newIndex = this.items.length + 1;
      this.items.push({ remark: '', value: newIndex.toString() });
    },
     deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //切换tab
    showTab(tab) {
      this.activeTab_one = tab;
    },
    DelEvt() {
      this.$confirm('是否永久删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CustDelApi({
          id: this.selectedId,
        }).then(res => {
          if (res.code == 1000) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogVisible = false
            this.getList()
          } else {
            alert(res.msg)
          }
        })
      })
    },
    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '1vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
      }
    },
    seekEvt() {
      const params = {
        register_time: this.register_time / 1000,
        name: this.names,
        type_id: this.type_id_one,
        area: this.areas,
        region: this.region_name,
        staff_id: this.staff_id,
        source: this.source_name,
        source_remark: this.source_remark,
        remark: this.remark,
        source_one: this.source_name,
      };
      if (this.selectedId) {
        params.id = this.selectedId;
      }
      editTwoApi(params).then(res => {
        if (res.code == 1000) {
          this.dialogVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    huaguo(row, column, cell, event) {
      this.selectedId = row.id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id
    },
    //点击打开弹窗事件
    openChildDialog(type) {
      if (type == 1) {
        this.selectedId = '',
          this.register_time = '',
          this.names = '',
          this.type_id_one = '',
          this.areas = '',
          this.region_name = '',
          this.staff_id = '',
          this.source_name = '',
          this.source_remark = '',
          this.remark = '',
          this.tableData_one = [],
          this.totalRowData = []
        this.customer = [],
          this.dialogVisible = true,
          this.activeTab = 'tab1'

      } else if (type == 2) {
        //打开收入管理弹窗详情页
        InfoTwoApi({
          id: this.selectedId,
        }).then((res) => {
          if (res.code == 1000) {
            this.customer = res.data.customer
            this.register_time = new Date(res.data.customer.register_time).getTime()
            this.names = res.data.customer.name;//用户名
            this.type_id_one = res.data.customer.type_id;
            this.areas = res.data.customer.area;
            this.staff_id = res.data.customer.staff_id;
            this.source_name = res.data.customer.source;
            this.source_remark = res.data.customer.source_remark;
            this.remark = res.data.remark;
            this.source_one = Object.values(this.source_one);
            this.region_one = Object.values(this.region_one);

            this.region_name = res.data.customer.region;

            this.tableData_one = res.projects
            this.totalRowData = res.totalRow
            this.dialogVisible = true

          }
        });
      }
    },


    minxEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.showNameColumn_box_four = false
        setTimeout(res => {
          // 在这里执行需要在异步操作完成后执行的代码
          this.activeTab = '1';
          this.showNameColumn = true
        }, 10)
      })
    },
    min_boxEvt() {
      this.$nextTick(() => {
        this.showNameColumn = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.showNameColumn_box_four = false
        setTimeout(res => {
          this.activeTab = '2';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box = true
        }, 10)
      })
    },
    min_oneEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.showNameColumn_box_four = false
        setTimeout(res => {
          this.activeTab = '3';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_one = true
        }, 10)
      })
    },
    min_twoEvt() {
      this.$nextTick(() => {
        this.showNameColumn_box_one = false
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_three = false
        this.showNameColumn_box_four = false

        setTimeout(res => {
          this.activeTab = '4';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_two = true
        }, 10)
      })
    },
    min_box_three() {
      this.$nextTick(() => {
        this.showNameColumn_box_four = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box = false
        this.showNameColumn = false
        setTimeout(res => {
          this.activeTab = '5';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_three = true
        }, 10)

      })
    },
    min_four() {
      this.$nextTick(() => {
        this.showNameColumn_box_two = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_three = false
        setTimeout(res => {
          this.activeTab = '6';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_four = true
        }, 10)

      })
    },


    limitEvt() {
      this.getList();
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },



    //市场维护
    staffChange(value) {
      this.staff = value;
      this.getList()
    },
    first_salesChange(value) {
      this.first_sales = value;
      this.getList()
    },

    //客户类型
    typeChange(type_id) {
      this.type = type_id;
      this.getList()
    },
    //来源方式
    sourceChange(key) {
      this.source = key
      this.getList()
    },
    //客户区域
    regionChange(key) {
      this.region = key
      this.getList()
    },

    //跟进人
    remark_creatorChange(key) {
      this.remark_creator = key
      this.getList()
    },

    //合作状态
    work_status_box(selectedValues) {
      this.work_status = selectedValues[0];
      this.getList();
    },

    //弹窗
    type_idChange(value) {
      this.type_id_one = value
    },
    //地區
    region_oneChange(value) {
      this.region_name = value
    },
    source_oneChange(value) {
      this.source_name = value
    },
    staff_oneChange(value) {
      this.staff_id = value
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList();
    },
    //点击后请求排序
    sortChangeEvt_two(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList_one();
    },
    getSummariesEvt(param) {
      const { columns, totalRowData } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRowData) {
          if (column.property == key) {
            sums[index] = this.totalRowData[key];
          }
        }
      });
      return sums;
    },
    getList_one(){
         InfoTwoApi({
          id: this.selectedId,
          orField: this.orField,
          orWhere: this.order,
        }).then((res) => {
          if (res.code == 1000) {
            this.customer = res.data.customer
            this.register_time = new Date(res.data.customer.register_time).getTime()
            this.names = res.data.customer.name;//用户名
            this.type_id_one = res.data.customer.type_id;
            this.areas = res.data.customer.area;
            this.staff_id = res.data.customer.staff_id;
            this.source_name = res.data.customer.source;
            this.source_remark = res.data.customer.source_remark;
            this.remark = res.data.remark;
            this.source_one = Object.values(this.source_one);
            this.region_one = Object.values(this.region_one);

            this.region_name = res.data.customer.region;

            this.tableData_one = res.projects
            this.totalRowData = res.totalRow
            this.dialogVisible = true

          }
        });
    },
    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);
      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        // page: this.currentPage1,
        limit: this.paginationInput,

        name: this.name,
        staff: this.staff,
        first_sales:this.first_sales,
        type: this.type,
        area: this.area,
        region: this.region,
        source: this.source,
        work_status: this.work_status,
        customer_remark_remark: this.customer_remark_remark,
        remark_creator: this.remark_creator,
        //最后合作
        last_cooperation_start: end_time_start ? end_time_start : '',
        last_cooperation_end: end_time_end ? end_time_end : '',
        //初次合作
        first_cooperation_start: income_time_start ? income_time_start : '',
        first_cooperation_end: income_time_end ? income_time_end : '',
        //跟进时间
        customer_remark_start: startTimestamp1 ? startTimestamp1 : '',
        customer_remark_end: endTimestamp1 ? endTimestamp1 : '',
      };
      ERPCustomerApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
          this.loading = false

        // this.totalRow = res.totalRow;
        // this.currentPage1 = res.page - 0;
      });

    },

    excelEvt() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);

      //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);


      console.log( this.first_sales,1111);
      
      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        // page: this.currentPage1,
        limit: this.paginationInput,

        name: this.name,
        staff: this.staff,
        first_sales: this.first_sales,
        type: this.type,
        area: this.area,
        region: this.region,
        source: this.source,
        work_status: this.work_status,
        customer_remark_remark: this.customer_remark_remark,
        remark_creator: this.remark_creator,
        //最后合作
        last_cooperation_start: end_time_start ? end_time_start : '',
        last_cooperation_end: end_time_end ? end_time_end : '',
        //初次合作
        first_cooperation_start: income_time_start ? income_time_start : '',
        first_cooperation_end: income_time_end ? income_time_end : '',
        //跟进时间
        customer_remark_start: startTimestamp1 ? startTimestamp1 : '',
        customer_remark_end: endTimestamp1 ? endTimestamp1 : '',
        excel: 1,
        activeTab: this.activeTab,
      };
      let genExcel = false;
      if (genExcel == false) {
        ERPCustomerApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }

    },
    //清除数据
    cleanUpEvt() {
      this.loading = true
      // 清空其他变量和重置表格数据
      this.value0 = '';
      this.value1 = '';
      this.value2 = '';
      this.currentPage1 = 1;
      this.name = '';
      this.staff = '';
      this.first_sales = '' ;  //市场开发的字段
      this.type = '';
      this.area = '';
      this.region = '';
      this.source = '';
      this.work_status = '';
      this.customer_remark_remark = '';
      this.remark_creator = '';
      this.$refs.sortTable.clearSort();

      ERPCustomerApi({
      }).then((res) => {
        this.tableData = res.data;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
          this.loading = false

      });
    },

  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
    'value1': function (newVal, oldVal) {
      this.isValue3Empty_2 = !newVal;
    },
    'value2': function (newVal, oldVal) {
      this.isValue3Empty_3 = !newVal;
    },

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/cutomer.less");



/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 50px;
  display: flex;

  div {
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}



/deep/.el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;
}

/deep/.el-tabs--border-card {
  border: none;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
}



.mainx {
  margin-top: 50px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/.el-tabs__header {
  width: 100%;
}

/deep/.el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}


/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/.el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/.el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/.el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/.el-table th.el-table__cell>.cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/.el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/::placeholder {
  color: #59565a;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}

// /deep/.el-input--suffix {
//   width: 137px;
// }


.maxs {
  background: #f00 !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

// .el-cascader /deep/.el-input__inner {
//   height: 27px !important;
//   min-width: 137px !important;
// }


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}




.btn2 {
  display: flex;
  align-items: center;
}

button {
  outline: none;
  border: 1px solid #d1d1d1;
  margin: 0 2px;
  /* 添加这一行 */
  width: 100px;
  height: 40px;
  cursor: pointer;
}

button.active {
  border-bottom: none;
  outline: none;
  background-color: #fff;
}



.whole {
  width: 100%;
  height: 855px;
  display: flex;

  /deep/.el-input {
    width: 280px;
    margin-left: 2px;
  }
}

.banner {
  margin-left: 380px;
  height: 835px;
  // overflow: auto;
  padding-right: 7px;
  width: 1150px;
}


.Completion_status {
  height: 320px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;

  /deep/.el-input__inner {
    display: flex;
    // width: 280px;
    align-items: center;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    height: 30px;
  }

}

/deep/.el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}



// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

.text_box_one {
  width: 282px;
  height: 150px;
  border-radius: 5px;
  border: 0.5px solid #D9D9D9;
}

.text_one {
  /deep/.el-form-item__content {
    margin-bottom: -10px;
  }
}


.content {
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  height: 645px;
  font-size: 12px;

  p:nth-child(1) {
    text-align: right;
    margin-right: 150px;
    font-size: 12px;
    text-indent: 1em
  }

  p:nth-child(2) {
    text-align: right;
    margin-right: 135px;
    font-size: 12px;
    text-indent: 1em
  }

  p:nth-child(3) {
    font-size: 12px;
    text-indent: 0.8em
  }

  /deep/ .el-table__fixed-body-wrapper {
    overflow: hidden !important;
  }


}

.seek {
  height: 140px;
  display: flex;
  justify-content: space-around;

  div {
    border: 1px solid #d1d1d1;
    width: 220px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #979797;
    border-radius: 5px;
    margin-top: 10px;
    height: 130px;
  }

  p {
    width: 170px;
    display: flex;
    font-size: 12px;
    text-indent: 0.8em;
    color: #fff;
  }
}

/deep/.el-dialog {
  background-color: #d9d9d9;
}


.content /deep/ .el-table--fit {
  margin-top: 35px;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 270px !important;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: 1142px;
}



/deep/.project_one{
  background: #c9e4d3 !important;
}
/deep/.project_two{
  background: #f4fff8 !important;
}

/deep/.project_three{
  background: #c9e4d3 !important;
}
/deep/.project_Free{
  background: #f4fff8 !important;
}
/deep/.project_sex_one{
  background: #e2f1d5 !important;
}
/deep/.project_sex_two{
  background: #f3f8ee !important;
}
/deep/.name_one{
  background: #f1c6c6 !important;
}
/deep/.name_two{
  background: #f8e7e7 !important;
}
/deep/.box_one{
  background: #c1dbec !important;
}
/deep/.box_two{
  background: #ddeaf3 !important;
}

/deep/.name_three{
  background: #ddf3e9 !important;
}
/deep/.name_four{
  background: #ddedf3 !important;
}

/deep/.name_three_one{
  background: #c0ebd8 !important;
}
/deep/.name_four_one{
  background: #c5e8f5 !important;
}


/deep/.el-table__footer tbody tr .project_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_two{
  background: #fff !important;
}

/deep/.el-table__footer tbody tr .project_three{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_Free{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_sex_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_sex_two{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_two{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .box_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .box_two{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_three{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_four{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_three_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .name_four_one{
  background: #fff !important;
}

@media screen and (min-width: 0px) and (max-width:1920px) {
  .manx /deep/.el-table__footer-wrapper {
    top: 235px !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 43px !important;
  }
}

@media screen and (min-width: 1921px) and (max-width:2560px) {
  .manx /deep/.el-table__footer-wrapper {
    top: 360px !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 45px !important;
  }
}

@media screen and (min-width: 2561px) and (max-width:3440px) {
  .content /deep/.el-table__footer-wrapper {
    top: 415px !important;
  }

  .manx /deep/.el-table--fit {
    margin-top: 65px !important;
  }

  .manx {
    overflow: hidden !important;
  }
}

@media screen and (min-width: 3441px) and (max-width:3840px) {
  .content /deep/.el-table__footer-wrapper {
     top: 620px !important;
  }

  .manx /deep/.el-table--fit {
    margin-top: 65px !important;
  }

  .manx {
    overflow: hidden !important;
  }
}

/deep/.el-form-item {
  margin-bottom: 0px !important;
}




.follow_up{
  height: 750px;
  width:1120px;
  margin-left: 10px;
}

.follow_up /deep/.el-textarea__inner{
  width:990px;

}

.span_box {
  position: absolute;
  left: 1px;
  top: 90px !important;
  height: 35px;
  width: 80px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 35px;
  text-align: left;
  padding-left: 13px;
}

.foll_up{
  min-height: 50px;
  width: 100%;
  border-bottom: 1px solid #d1d1d1;
  text-align: left;
  margin: 12px 0px;
  display: flex;
}
.img_se{
   width: 20px;
   height: 20px;
   margin-top: 3px;
   cursor: pointer;
   position: absolute;
   right:30px;
   display: none;
}

.foll_up:hover .img_se{
  display: block;
}
/deep/.sousuo {
  margin: 90px 0 0 325px !important;
  width: 1500px;
  background-color:#fff !important;
}
/deep/::placeholder {
  color: #e5e5e5;
}
/deep/.sousuo .el-dialog__body {
  font-size: 13px !important;
}
</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}

.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/src/Customer_management/index.vue